import { useState, useEffect, useCallback, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import {
  Package,
  Truck,
  DollarSign,
  TrendingUp,
  AlertTriangle,
  ArrowRight,
  MapPin,
  Activity,
} from 'lucide-react';
import "leaflet/dist/leaflet.css";

const API_URL = process.env.REACT_APP_BACKEND_URL;

// 3-digit ZIP prefix → approximate [lat, lon] centroid
const ZIP_COORDS = {
  "005": [18.22,-66.59], "006": [18.22,-66.59], "007": [18.22,-66.59],
  "008": [18.22,-66.59], "009": [18.22,-66.59],
  "010": [42.11,-72.59], "011": [42.34,-72.64], "012": [42.37,-72.52],
  "013": [42.25,-71.82], "014": [42.62,-71.35], "015": [42.27,-71.80],
  "016": [42.27,-71.80], "017": [42.44,-71.72], "018": [42.54,-70.98],
  "019": [42.54,-70.88], "020": [42.18,-71.00], "021": [42.36,-71.06],
  "022": [42.36,-71.06], "023": [42.10,-70.93], "024": [41.72,-70.62],
  "025": [41.72,-70.62], "026": [41.65,-70.29], "027": [41.56,-70.62],
  "028": [41.63,-71.30], "029": [41.63,-71.30],
  "030": [43.00,-71.46], "031": [43.00,-71.46], "032": [43.04,-71.01],
  "033": [42.86,-71.54], "034": [43.27,-71.56], "035": [43.72,-71.52],
  "036": [44.09,-70.21], "037": [43.91,-69.97], "038": [43.08,-70.75],
  "039": [43.08,-70.75],
  "040": [43.66,-70.27], "041": [44.10,-69.11], "042": [44.55,-69.63],
  "043": [44.33,-69.79], "044": [44.80,-68.78], "045": [47.20,-68.22],
  "046": [44.50,-67.90], "047": [44.10,-70.21], "048": [44.10,-70.21],
  "049": [44.30,-70.52],
  "050": [44.26,-72.58], "051": [44.26,-72.58], "052": [44.26,-72.58],
  "053": [43.61,-72.97], "054": [44.26,-72.58], "055": [44.26,-72.58],
  "056": [44.49,-73.21], "057": [43.73,-72.28], "058": [44.01,-72.12],
  "059": [44.94,-71.54],
  "060": [41.76,-72.67], "061": [41.76,-72.67], "062": [41.76,-72.67],
  "063": [41.20,-73.19], "064": [41.35,-72.09], "065": [41.56,-72.65],
  "066": [41.05,-73.54], "067": [41.88,-72.36], "068": [41.06,-73.55],
  "069": [41.06,-73.55],
  "070": [40.72,-74.17], "071": [40.82,-74.12], "072": [40.82,-74.12],
  "073": [40.77,-74.18], "074": [40.93,-74.18], "075": [40.93,-74.18],
  "076": [40.93,-74.05], "077": [40.33,-74.08], "078": [40.93,-74.18],
  "079": [41.05,-74.74], "080": [39.95,-75.17], "081": [39.95,-75.17],
  "082": [40.22,-74.76], "083": [40.22,-74.76], "084": [39.71,-75.12],
  "085": [40.22,-74.76], "086": [40.22,-74.76], "087": [40.31,-74.60],
  "088": [40.31,-74.60], "089": [40.31,-74.60],
  "100": [40.71,-74.01], "101": [40.71,-74.01], "102": [40.71,-74.01],
  "103": [40.58,-74.15], "104": [40.71,-74.01], "105": [41.03,-73.76],
  "106": [41.03,-73.76], "107": [40.92,-73.85], "108": [40.77,-73.71],
  "109": [40.77,-73.71], "110": [40.71,-73.85], "111": [40.71,-73.85],
  "112": [40.65,-73.95], "113": [40.65,-73.95], "114": [40.65,-73.85],
  "115": [40.72,-73.79], "116": [40.72,-73.79], "117": [40.72,-73.79],
  "118": [40.72,-73.79], "119": [40.72,-73.79],
  "120": [42.65,-73.76], "121": [42.65,-73.76], "122": [42.65,-73.76],
  "123": [42.10,-74.01], "124": [41.70,-74.01], "125": [42.10,-72.61],
  "126": [42.10,-72.61], "127": [42.10,-72.61], "128": [42.10,-74.62],
  "129": [42.10,-73.76],
  "130": [43.05,-76.15], "131": [43.05,-76.15], "132": [43.05,-76.15],
  "133": [43.22,-75.45], "134": [43.22,-75.45], "135": [43.22,-75.45],
  "136": [43.22,-75.45], "137": [42.10,-75.91], "138": [43.05,-76.14],
  "139": [43.05,-76.14],
  "140": [42.88,-78.88], "141": [42.88,-78.88], "142": [42.88,-78.88],
  "143": [42.09,-79.24], "144": [43.16,-77.61], "145": [43.16,-77.61],
  "146": [43.16,-77.61], "147": [42.09,-76.80], "148": [42.45,-76.51],
  "149": [42.45,-76.51],
  "150": [40.44,-79.99], "151": [40.44,-79.99], "152": [40.44,-79.99],
  "153": [40.44,-79.99], "154": [40.44,-79.99], "155": [40.44,-79.99],
  "156": [40.44,-79.99], "157": [40.44,-79.99], "158": [40.44,-79.99],
  "159": [40.44,-79.99], "160": [41.24,-80.51], "161": [41.24,-80.51],
  "162": [41.24,-80.51], "163": [41.24,-80.51], "164": [41.24,-80.51],
  "165": [41.63,-80.14], "166": [41.63,-80.14], "167": [41.63,-80.14],
  "168": [40.80,-77.87], "169": [40.56,-75.97],
  "170": [40.26,-76.88], "171": [40.26,-76.88], "172": [40.26,-76.88],
  "173": [40.26,-76.88], "174": [40.26,-76.88], "175": [40.00,-77.00],
  "176": [40.00,-77.00], "177": [41.24,-77.00], "178": [40.02,-76.31],
  "179": [40.02,-76.31],
  "180": [40.72,-75.23], "181": [40.61,-75.37], "182": [41.41,-75.66],
  "183": [40.72,-75.23], "184": [41.41,-75.66], "185": [41.41,-75.66],
  "186": [41.41,-75.66], "187": [41.41,-75.66], "188": [41.41,-75.66],
  "189": [40.02,-75.31],
  "190": [39.95,-75.17], "191": [39.95,-75.17], "192": [39.95,-75.17],
  "193": [39.95,-75.17], "194": [39.95,-75.17], "195": [39.95,-75.17],
  "196": [39.95,-75.17],
  "197": [39.74,-75.54], "198": [39.74,-75.54], "199": [39.74,-75.54],
  "200": [38.89,-77.04], "201": [38.89,-77.04], "202": [38.89,-77.04],
  "203": [38.89,-77.04], "204": [38.89,-77.04], "205": [38.89,-77.04],
  "206": [38.89,-77.04], "207": [38.89,-77.04], "208": [39.01,-77.04],
  "209": [38.89,-77.04],
  "210": [39.29,-76.61], "211": [39.29,-76.61], "212": [39.29,-76.61],
  "213": [39.29,-76.61], "214": [39.29,-76.61], "215": [39.29,-76.61],
  "216": [39.29,-76.61], "217": [39.29,-76.61], "218": [38.65,-76.88],
  "219": [38.95,-77.28],
  "220": [38.89,-77.04], "221": [38.89,-77.04], "222": [38.89,-77.04],
  "223": [38.89,-77.04], "224": [38.89,-77.04], "225": [37.54,-77.43],
  "226": [38.30,-77.46], "227": [38.30,-77.46], "228": [38.30,-77.46],
  "229": [37.54,-77.43],
  "230": [37.54,-77.43], "231": [37.54,-77.43], "232": [37.54,-77.43],
  "233": [36.85,-76.29], "234": [36.85,-76.29], "235": [36.85,-76.29],
  "236": [36.85,-76.29], "237": [36.85,-76.29], "238": [37.54,-77.43],
  "239": [36.85,-76.29],
  "240": [37.27,-79.94], "241": [37.27,-79.94], "242": [37.27,-79.94],
  "243": [37.27,-79.94], "244": [38.15,-79.06], "245": [37.78,-81.18],
  "246": [37.38,-81.10], "247": [37.38,-81.10], "248": [38.35,-82.59],
  "249": [38.35,-82.59],
  "250": [38.35,-81.63], "251": [38.35,-81.63], "252": [38.35,-81.63],
  "253": [38.35,-81.63], "254": [38.35,-81.63], "255": [39.31,-81.56],
  "256": [39.31,-81.56], "257": [39.31,-81.56], "258": [37.78,-81.18],
  "259": [37.78,-81.18],
  "260": [41.08,-85.14], "261": [41.08,-85.14], "262": [41.08,-85.14],
  "263": [38.82,-80.46], "264": [38.82,-80.46], "265": [38.82,-80.46],
  "266": [38.82,-80.46], "267": [38.82,-80.46], "268": [39.28,-80.30],
  "269": [39.28,-80.30],
  "270": [36.07,-79.79], "271": [36.07,-79.79], "272": [36.07,-79.79],
  "273": [36.07,-79.79], "274": [35.23,-80.84], "275": [35.23,-80.84],
  "276": [35.23,-80.84], "277": [35.23,-80.84], "278": [35.23,-80.84],
  "279": [35.23,-80.84],
  "280": [35.23,-80.84], "281": [35.23,-80.84], "282": [35.23,-80.84],
  "283": [35.23,-80.84], "284": [34.23,-77.95], "285": [35.23,-80.84],
  "286": [35.57,-82.55], "287": [35.57,-82.55], "288": [35.57,-82.55],
  "289": [34.93,-82.01],
  "290": [34.00,-81.03], "291": [34.00,-81.03], "292": [34.00,-81.03],
  "293": [34.00,-81.03], "294": [34.00,-81.03], "295": [34.00,-81.03],
  "296": [34.00,-81.03], "297": [35.22,-81.02], "298": [34.85,-82.40],
  "299": [32.08,-81.10],
  "300": [33.75,-84.39], "301": [33.75,-84.39], "302": [33.75,-84.39],
  "303": [33.75,-84.39], "304": [33.75,-84.39], "305": [33.75,-84.39],
  "306": [33.75,-84.39], "307": [33.75,-84.39], "308": [33.75,-84.39],
  "309": [33.75,-84.39],
  "310": [32.08,-81.10], "311": [32.08,-81.10], "312": [31.56,-84.16],
  "313": [31.56,-84.16], "314": [31.56,-84.16], "315": [32.54,-84.97],
  "316": [32.54,-84.97], "317": [32.54,-84.97], "318": [30.83,-83.28],
  "319": [30.83,-83.28],
  "320": [30.33,-81.66], "321": [28.53,-81.38], "322": [30.33,-81.66],
  "323": [30.44,-84.28], "324": [30.44,-84.28], "325": [28.53,-81.38],
  "326": [29.65,-82.33], "327": [29.65,-82.33], "328": [29.65,-82.33],
  "329": [28.53,-81.38],
  "330": [25.77,-80.19], "331": [25.77,-80.19], "332": [25.77,-80.19],
  "333": [25.77,-80.19], "334": [27.34,-82.54], "335": [27.95,-82.46],
  "336": [27.95,-82.46], "337": [27.95,-82.46], "338": [27.95,-82.46],
  "339": [25.77,-80.19],
  "340": [21.31,-157.85], "341": [20.88,-156.47],
  "342": [26.14,-80.14], "344": [27.34,-82.54], "346": [27.34,-82.54],
  "347": [28.53,-81.38], "349": [26.14,-80.14],
  "350": [33.52,-86.80], "351": [33.52,-86.80], "352": [33.52,-86.80],
  "353": [33.52,-86.80], "354": [33.52,-86.80], "355": [33.52,-86.80],
  "356": [34.73,-86.59], "357": [34.73,-86.59], "358": [34.73,-86.59],
  "359": [32.36,-86.30], "360": [32.36,-86.30], "361": [32.36,-86.30],
  "362": [31.69,-85.37], "363": [31.69,-85.37], "364": [34.20,-88.10],
  "365": [32.36,-86.30], "366": [32.36,-86.30], "367": [32.36,-86.30],
  "368": [31.21,-85.40], "369": [31.21,-85.40],
  "370": [36.17,-86.78], "371": [36.17,-86.78], "372": [36.17,-86.78],
  "373": [35.15,-90.05], "374": [35.15,-90.05], "375": [35.15,-90.05],
  "376": [35.15,-90.05], "377": [35.96,-83.92], "378": [35.96,-83.92],
  "379": [35.96,-83.92],
  "380": [35.15,-90.05], "381": [35.15,-90.05], "382": [35.15,-90.05],
  "383": [35.15,-90.05], "384": [35.15,-90.05], "385": [35.15,-90.05],
  "386": [34.20,-88.10], "387": [34.20,-88.10], "388": [34.20,-88.10],
  "389": [34.20,-88.10],
  "390": [32.30,-90.18], "391": [32.30,-90.18], "392": [32.30,-90.18],
  "393": [32.30,-90.18], "394": [30.39,-89.05], "395": [30.39,-89.05],
  "396": [32.30,-90.18], "397": [32.30,-90.18],
  "400": [38.25,-85.76], "401": [38.25,-85.76], "402": [38.25,-85.76],
  "403": [38.25,-85.76], "404": [38.25,-85.76], "405": [38.03,-84.50],
  "406": [38.03,-84.50], "407": [37.16,-87.13], "408": [36.86,-89.02],
  "409": [36.86,-89.02],
  "410": [39.10,-84.51], "411": [37.10,-84.61], "412": [37.10,-84.61],
  "413": [37.10,-84.61], "414": [37.10,-84.61], "415": [37.10,-84.61],
  "416": [37.10,-84.61], "417": [37.10,-84.61], "418": [37.74,-87.12],
  "420": [36.87,-86.98], "421": [36.87,-86.98], "422": [36.87,-86.98],
  "423": [36.87,-86.98], "424": [37.47,-82.52], "425": [37.74,-87.12],
  "426": [37.74,-87.12], "427": [37.74,-87.12],
  "430": [39.96,-82.99], "431": [39.96,-82.99], "432": [39.96,-82.99],
  "433": [39.96,-82.99], "434": [40.36,-82.60], "435": [40.36,-82.60],
  "436": [40.36,-82.60], "437": [40.36,-82.60], "438": [41.50,-82.00],
  "439": [39.96,-82.99],
  "440": [41.50,-81.69], "441": [41.50,-81.69], "442": [41.50,-81.69],
  "443": [41.50,-81.69], "444": [41.10,-81.52], "445": [41.10,-80.65],
  "446": [41.10,-80.65], "447": [41.10,-80.65], "448": [41.50,-83.55],
  "449": [41.02,-83.65],
  "450": [39.10,-84.51], "451": [39.10,-84.51], "452": [39.10,-84.51],
  "453": [39.76,-84.19], "454": [39.76,-84.19], "455": [40.06,-83.01],
  "456": [39.96,-82.99], "457": [39.96,-82.99], "458": [41.68,-83.56],
  "459": [39.40,-83.81],
  "460": [39.77,-86.16], "461": [39.77,-86.16], "462": [39.77,-86.16],
  "463": [39.77,-86.16], "464": [39.77,-86.16], "465": [41.08,-85.14],
  "466": [41.08,-85.14], "467": [41.08,-85.14], "468": [41.08,-85.14],
  "469": [40.56,-85.66],
  "470": [38.81,-87.59], "471": [38.81,-87.59], "472": [38.81,-87.59],
  "473": [40.41,-86.88], "474": [40.41,-86.88], "475": [40.41,-86.88],
  "476": [41.68,-85.99], "477": [41.68,-85.99], "478": [39.19,-86.53],
  "479": [41.68,-87.14],
  "480": [42.33,-83.05], "481": [42.33,-83.05], "482": [42.33,-83.05],
  "483": [42.33,-83.05], "484": [42.72,-84.56], "485": [42.72,-84.56],
  "486": [43.60,-84.24], "487": [43.60,-84.24], "488": [42.72,-84.56],
  "489": [42.09,-83.75],
  "490": [42.33,-85.18], "491": [42.33,-85.18], "492": [43.10,-86.24],
  "493": [42.97,-85.67], "494": [44.76,-85.62], "495": [44.76,-85.62],
  "496": [44.76,-85.62], "497": [46.36,-84.35], "498": [46.36,-84.35],
  "499": [46.36,-84.35],
  "500": [41.59,-93.62], "501": [41.59,-93.62], "502": [41.59,-93.62],
  "503": [42.50,-92.33], "504": [42.50,-92.33], "505": [41.00,-95.86],
  "506": [41.00,-95.86], "507": [41.59,-93.62], "508": [41.59,-93.62],
  "509": [41.59,-93.62],
  "510": [42.50,-96.40], "511": [42.50,-96.40], "512": [43.07,-94.87],
  "513": [43.07,-94.87], "514": [43.48,-92.46], "515": [42.50,-94.17],
  "516": [41.59,-93.62], "520": [42.50,-96.40],
  "521": [42.50,-96.40], "522": [41.02,-92.41], "523": [42.01,-91.64],
  "524": [42.01,-91.64], "525": [41.59,-93.62], "526": [41.59,-93.62],
  "527": [42.50,-92.33], "528": [43.10,-91.78],
  "530": [43.04,-88.00], "531": [43.04,-88.00], "532": [43.04,-88.00],
  "533": [43.04,-88.00], "534": [43.04,-88.00], "535": [43.04,-88.00],
  "537": [43.04,-89.40], "538": [44.52,-87.99], "539": [44.52,-87.99],
  "540": [44.52,-87.99], "541": [44.52,-88.02], "542": [44.52,-88.02],
  "543": [44.52,-88.02], "544": [44.52,-88.02], "545": [44.52,-88.02],
  "546": [45.47,-91.76], "547": [45.47,-91.76], "548": [45.47,-91.76],
  "549": [45.47,-91.76],
  "550": [44.98,-93.27], "551": [44.98,-93.27], "552": [44.98,-93.27],
  "553": [44.98,-93.27], "554": [44.98,-93.27], "555": [44.98,-93.27],
  "556": [47.49,-92.53], "557": [47.49,-92.53], "558": [47.49,-92.53],
  "559": [43.90,-92.47], "560": [43.65,-93.37], "561": [43.65,-93.37],
  "562": [43.90,-92.47], "563": [43.65,-93.37], "564": [45.12,-95.04],
  "565": [43.90,-92.47], "566": [47.49,-96.79], "567": [46.87,-96.79],
  "569": [44.98,-93.27],
  "570": [43.55,-96.73], "571": [43.55,-96.73], "572": [43.55,-96.73],
  "573": [44.37,-100.35], "574": [44.37,-100.35], "575": [44.37,-100.35],
  "576": [44.37,-100.35], "577": [44.37,-100.35],
  "580": [46.87,-96.79], "581": [46.87,-96.79], "582": [47.92,-97.08],
  "583": [47.92,-97.08], "584": [46.87,-100.78], "585": [46.87,-100.78],
  "586": [48.23,-101.30], "587": [48.23,-101.30], "588": [46.87,-100.78],
  "589": [46.87,-100.78],
  "590": [46.60,-112.03], "591": [46.60,-112.03], "592": [46.60,-112.03],
  "593": [47.50,-111.30], "594": [46.60,-112.03], "595": [47.50,-111.30],
  "596": [47.50,-111.30], "597": [47.50,-111.30], "598": [47.50,-111.30],
  "599": [46.87,-113.99],
  "600": [41.88,-87.63], "601": [41.88,-87.63], "602": [41.88,-87.63],
  "603": [41.88,-87.63], "604": [41.88,-87.63], "605": [41.88,-87.63],
  "606": [41.88,-87.63], "607": [41.88,-87.63], "608": [41.88,-87.63],
  "609": [41.88,-87.63],
  "610": [42.09,-88.43], "611": [42.09,-88.43], "612": [41.62,-88.84],
  "613": [41.62,-88.84], "614": [41.62,-88.84], "615": [42.09,-89.09],
  "616": [42.09,-89.09], "617": [42.09,-89.09], "618": [39.52,-88.06],
  "619": [39.52,-88.06],
  "620": [38.63,-90.20], "621": [38.63,-90.20], "622": [38.63,-90.20],
  "623": [37.68,-89.62], "624": [38.52,-89.98], "625": [39.80,-89.65],
  "626": [39.80,-89.65], "627": [39.80,-89.65], "628": [40.12,-88.24],
  "629": [40.12,-88.24],
  "630": [38.63,-90.20], "631": [38.63,-90.20], "633": [38.63,-90.20],
  "634": [38.63,-90.20], "635": [38.63,-90.20], "636": [38.63,-90.20],
  "637": [37.31,-93.29], "638": [37.31,-93.29], "639": [37.31,-93.29],
  "640": [39.10,-94.58], "641": [39.10,-94.58], "644": [37.20,-94.71],
  "645": [37.20,-94.71], "646": [37.20,-94.71], "647": [38.56,-92.17],
  "648": [38.56,-92.17], "649": [37.96,-91.77],
  "650": [38.56,-92.17], "651": [38.56,-92.17], "652": [39.80,-91.53],
  "653": [39.80,-91.53], "654": [37.20,-89.96], "655": [37.20,-89.96],
  "656": [37.20,-89.96], "657": [37.20,-89.96], "658": [36.74,-90.42],
  "660": [37.69,-97.34], "661": [37.69,-97.34], "662": [38.03,-97.91],
  "664": [38.03,-97.91], "665": [38.03,-97.91], "666": [38.03,-97.91],
  "667": [38.03,-97.91], "668": [37.69,-97.34], "669": [38.56,-99.33],
  "670": [37.69,-97.34], "671": [37.69,-97.34], "672": [38.56,-99.33],
  "673": [39.04,-95.68], "674": [39.04,-95.68], "675": [39.04,-95.68],
  "676": [38.56,-99.33], "677": [38.56,-99.33], "678": [30.27,-97.74],
  "679": [38.56,-99.33],
  "680": [41.26,-95.94], "681": [41.26,-95.94], "682": [41.26,-95.94],
  "683": [41.26,-95.94], "684": [41.26,-95.94], "685": [40.81,-96.69],
  "686": [40.81,-96.69], "687": [40.81,-96.69], "688": [40.81,-96.69],
  "689": [41.26,-95.94],
  "690": [40.81,-98.39], "691": [40.81,-98.39], "692": [41.85,-97.60],
  "693": [41.85,-97.60], "694": [42.50,-98.34],
  "700": [29.95,-90.07], "701": [29.95,-90.07], "703": [30.45,-91.18],
  "704": [30.45,-91.18], "705": [30.45,-91.18], "706": [31.32,-92.45],
  "707": [29.95,-90.07], "708": [29.95,-90.07], "710": [32.51,-93.74],
  "711": [32.51,-93.74], "712": [32.51,-93.74], "713": [33.54,-92.83],
  "714": [33.54,-92.83], "716": [34.75,-92.29], "717": [34.75,-92.29],
  "718": [34.75,-92.29], "719": [34.75,-92.29],
  "720": [34.75,-92.29], "721": [34.75,-92.29], "722": [34.75,-92.29],
  "723": [34.75,-92.29], "724": [34.75,-92.29], "725": [34.75,-92.29],
  "726": [36.08,-94.17], "727": [36.08,-94.17], "728": [36.08,-94.17],
  "729": [36.08,-94.17],
  "730": [35.47,-97.52], "731": [35.47,-97.52], "733": [35.47,-97.52],
  "734": [35.47,-97.52], "735": [35.47,-97.52], "736": [35.47,-97.52],
  "737": [36.15,-95.99], "738": [35.47,-97.52], "739": [36.40,-99.40],
  "740": [36.15,-95.99], "741": [36.15,-95.99], "743": [36.15,-95.99],
  "744": [36.15,-95.99], "745": [34.91,-95.77], "746": [34.91,-95.77],
  "747": [34.91,-95.77], "748": [34.91,-95.77], "749": [34.91,-95.77],
  "750": [32.78,-96.80], "751": [32.78,-96.80], "752": [32.99,-96.75],
  "753": [32.78,-96.80], "754": [32.78,-96.80], "755": [33.44,-94.05],
  "756": [31.55,-94.63], "757": [31.55,-94.63], "758": [31.55,-94.63],
  "759": [31.55,-94.63],
  "760": [32.73,-97.33], "761": [32.73,-97.33], "762": [32.73,-97.33],
  "763": [33.22,-97.13], "764": [31.55,-97.15], "765": [31.55,-97.15],
  "766": [32.44,-99.73], "767": [32.44,-99.73], "768": [32.44,-99.73],
  "769": [32.44,-99.73],
  "770": [29.76,-95.37], "771": [29.76,-95.37], "772": [29.76,-95.37],
  "773": [29.76,-95.37], "774": [29.76,-95.37], "775": [29.76,-95.37],
  "776": [29.76,-95.37], "777": [29.76,-95.37], "778": [28.70,-100.55],
  "779": [26.20,-98.24],
  "780": [29.42,-98.49], "781": [29.42,-98.49], "782": [29.42,-98.49],
  "783": [27.80,-97.40], "784": [27.80,-97.40], "785": [27.80,-97.40],
  "786": [30.27,-97.74], "787": [30.27,-97.74], "788": [29.42,-98.49],
  "789": [30.27,-97.74],
  "790": [31.76,-106.49], "791": [31.76,-106.49], "792": [31.76,-106.49],
  "793": [33.43,-101.69], "794": [33.43,-101.69], "795": [32.44,-99.73],
  "796": [32.44,-99.73], "797": [32.44,-99.73], "798": [31.76,-106.49],
  "799": [31.76,-106.49],
  "800": [39.74,-104.98], "801": [39.74,-104.98], "802": [39.74,-104.98],
  "803": [39.74,-104.98], "804": [39.74,-104.98], "805": [39.74,-104.98],
  "806": [39.74,-104.98], "807": [39.74,-104.98], "808": [38.84,-104.82],
  "809": [38.84,-104.82],
  "810": [38.84,-104.82], "811": [38.84,-104.82], "812": [38.25,-104.62],
  "813": [37.68,-105.97], "814": [38.25,-104.62], "815": [37.17,-104.50],
  "816": [39.09,-108.55], "817": [37.95,-107.71], "818": [37.95,-107.71],
  "819": [37.95,-107.71],
  "820": [41.14,-104.82], "821": [41.14,-104.82], "822": [41.14,-104.82],
  "823": [42.85,-106.32], "824": [41.14,-104.82], "825": [42.85,-106.32],
  "826": [42.85,-106.32], "827": [42.85,-106.32], "828": [42.85,-106.32],
  "829": [41.14,-104.82],
  "830": [43.49,-110.78], "831": [43.49,-110.78], "832": [43.37,-116.57],
  "833": [43.49,-116.20], "834": [43.49,-116.20], "835": [46.41,-116.99],
  "836": [43.37,-116.57], "837": [43.37,-116.57], "838": [47.66,-117.43],
  "840": [40.76,-111.89], "841": [40.76,-111.89], "842": [40.76,-111.89],
  "843": [40.76,-111.89], "844": [40.76,-111.89], "845": [40.76,-111.89],
  "846": [40.76,-111.89], "847": [40.76,-111.89],
  "850": [33.45,-112.07], "851": [33.45,-112.07], "852": [33.45,-112.07],
  "853": [33.45,-112.07], "855": [33.45,-112.07], "856": [32.12,-110.93],
  "857": [32.12,-110.93], "859": [34.57,-112.47], "860": [34.57,-112.47],
  "863": [33.45,-112.07], "864": [33.45,-112.07], "865": [35.08,-106.65],
  "870": [35.08,-106.65], "871": [35.08,-106.65], "872": [35.08,-106.65],
  "873": [35.08,-106.65], "874": [36.70,-108.21], "875": [35.08,-106.65],
  "876": [35.08,-106.65], "877": [35.08,-106.65], "878": [33.39,-104.52],
  "879": [33.39,-104.52],
  "880": [32.32,-106.77], "881": [32.32,-106.77], "882": [35.08,-106.65],
  "883": [35.08,-106.65], "884": [35.08,-106.65],
  "885": [31.76,-106.49],
  "890": [36.17,-115.14], "891": [36.17,-115.14],
  "893": [39.52,-119.81], "894": [39.52,-119.81], "895": [39.52,-119.81],
  "897": [39.52,-119.81], "898": [39.52,-119.81],
  "900": [34.05,-118.24], "901": [34.05,-118.24], "902": [33.99,-118.17],
  "903": [33.99,-118.17], "904": [34.05,-118.24], "905": [33.88,-118.18],
  "906": [33.88,-118.18], "907": [33.88,-118.18], "908": [33.88,-118.18],
  "910": [33.88,-118.18], "911": [33.88,-118.18], "912": [33.88,-118.18],
  "913": [33.88,-118.18], "914": [33.88,-118.18], "915": [34.05,-118.24],
  "916": [34.05,-118.24], "917": [34.05,-118.24], "918": [34.05,-118.24],
  "919": [32.72,-117.16], "920": [32.72,-117.16], "921": [32.72,-117.16],
  "922": [32.72,-117.16], "923": [34.09,-117.44], "924": [34.09,-117.44],
  "925": [33.88,-118.18], "926": [33.88,-118.18], "927": [33.88,-118.18],
  "928": [33.60,-114.60],
  "930": [33.60,-114.60], "931": [34.41,-119.70], "932": [35.37,-119.02],
  "933": [35.37,-119.02], "934": [35.37,-119.02], "935": [35.37,-119.02],
  "936": [36.74,-119.77], "937": [36.74,-119.77], "938": [36.74,-119.77],
  "939": [36.74,-119.77],
  "940": [37.34,-121.89], "941": [37.77,-122.42], "942": [38.55,-121.47],
  "943": [37.34,-121.89], "944": [37.34,-121.89], "945": [37.34,-122.04],
  "946": [37.87,-122.27], "947": [37.34,-122.04], "948": [37.34,-122.04],
  "949": [37.87,-122.27],
  "950": [37.34,-121.89], "951": [37.34,-121.89], "952": [37.34,-121.89],
  "953": [37.34,-121.89], "954": [37.34,-121.89], "955": [40.58,-122.39],
  "956": [38.55,-121.47], "957": [38.55,-121.47], "958": [38.55,-121.47],
  "959": [38.55,-121.47],
  "960": [39.52,-119.81], "961": [39.52,-119.81],
  "970": [45.52,-122.68], "971": [45.52,-122.68], "972": [45.52,-122.68],
  "973": [44.94,-123.03], "974": [44.94,-123.03], "975": [42.32,-122.87],
  "976": [42.32,-122.87], "977": [42.32,-122.87], "978": [44.94,-123.03],
  "979": [46.19,-123.83],
  "980": [47.61,-122.33], "981": [47.61,-122.33], "982": [47.61,-122.33],
  "983": [47.61,-122.33], "984": [47.61,-122.33], "985": [47.61,-122.33],
  "986": [47.61,-122.33], "987": [47.61,-122.33], "988": [46.73,-117.00],
  "989": [47.50,-120.50], "990": [47.66,-117.43], "991": [47.66,-117.43],
  "992": [47.66,-117.43], "993": [47.66,-117.43], "994": [47.66,-117.43],
  "995": [61.22,-149.90], "996": [64.84,-147.72], "997": [64.84,-147.72],
  "998": [55.34,-131.68], "999": [55.34,-131.68],
};

function zipToCoords(zip) {
  if (!zip) return null;
  return ZIP_COORDS[zip.slice(0, 3)] || null;
}

const STATUS_MARKER_COLOR = {
  quoted:       "#a855f7",
  deposit_paid: "#0ea5e9",
  posted:       "#a855f7",
  dispatched:   "#f97316",
  picked_up:    "#6366f1",
  in_transit:   "#6366f1",
  delivered:    "#14b8a6",
  cancelled:    "#ef4444",
  refunded:     "#ef4444",
  closed:       "#6b7280",
};

function FleetMap({ loads }) {
  const mapRef = useRef(null);
  const leafletMap = useRef(null);
  const markersLayer = useRef(null);

  useEffect(() => {
    if (!mapRef.current) return;
    // Guard against StrictMode double-invoke: Leaflet stamps _leaflet_id on the container
    if (mapRef.current._leaflet_id) return;
    if (leafletMap.current) return;

    import("leaflet").then((L) => {
      // Re-check inside async callback — StrictMode may have already cleaned up
      if (!mapRef.current || mapRef.current._leaflet_id) return;

      delete L.Icon.Default.prototype._getIconUrl;
      L.Icon.Default.mergeOptions({
        iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
        iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
        shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
      });

      const map = L.map(mapRef.current, {
        center: [39.5, -98.35],
        zoom: 4,
        zoomControl: true,
        scrollWheelZoom: false,
        attributionControl: true,
      });

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: "© OpenStreetMap contributors",
        maxZoom: 18,
      }).addTo(map);

      leafletMap.current = map;
      markersLayer.current = L.layerGroup().addTo(map);
    });

    return () => {
      if (leafletMap.current) {
        leafletMap.current.remove();
        leafletMap.current = null;
        markersLayer.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (!leafletMap.current || !markersLayer.current) return;
    import("leaflet").then((L) => {
      markersLayer.current.clearLayers();
      loads.forEach((load) => {
        const c = zipToCoords(load.pickup_zip);
        if (!c) return;
        const color = STATUS_MARKER_COLOR[load.status] || "#6b7280";
        const circle = L.circleMarker([c[0], c[1]], {
          radius: 7,
          fillColor: color,
          color: "#fff",
          weight: 1.5,
          opacity: 1,
          fillOpacity: 0.85,
        });
        circle.bindTooltip(
          `<strong>${load.year || ""} ${load.vehicle_make || ""} ${load.vehicle_model || ""}</strong><br/>
           ${load.pickup_zip} → ${load.delivery_zip}<br/>
           <span style="text-transform:capitalize">${(load.status || "").replace(/_/g, " ")}</span>`,
          { sticky: true }
        );
        markersLayer.current.addLayer(circle);
      });
    });
  }, [loads]);

  return <div ref={mapRef} style={{ width: "100%", height: 380 }} />;
}

const STATUS_CONFIG = {
  new:          { label: 'New',          dot: 'bg-slate-400',   bg: 'bg-slate-400/10',   text: 'text-slate-500 dark:text-slate-400'      },
  quoted:       { label: 'Quoted',       dot: 'bg-violet-500',  bg: 'bg-violet-500/10',  text: 'text-violet-600 dark:text-violet-400'    },
  deposit_paid: { label: 'Deposit Paid', dot: 'bg-sky-500',     bg: 'bg-sky-500/10',     text: 'text-sky-600 dark:text-sky-400'          },
  posted:       { label: 'Posted',       dot: 'bg-purple-500',  bg: 'bg-purple-500/10',  text: 'text-purple-600 dark:text-purple-400'    },
  dispatched:   { label: 'Dispatched',   dot: 'bg-orange-500',  bg: 'bg-orange-500/10',  text: 'text-orange-600 dark:text-orange-400'    },
  picked_up:    { label: 'Picked Up',    dot: 'bg-indigo-500',  bg: 'bg-indigo-500/10',  text: 'text-indigo-600 dark:text-indigo-400'    },
  delivered:    { label: 'Delivered',    dot: 'bg-teal-500',    bg: 'bg-teal-500/10',    text: 'text-teal-600 dark:text-teal-400'        },
  cancelled:    { label: 'Cancelled',    dot: 'bg-red-500',     bg: 'bg-red-500/10',     text: 'text-red-600 dark:text-red-400'          },
};

function greeting() {
  const h = new Date().getHours();
  if (h < 12) return 'Good morning';
  if (h < 17) return 'Good afternoon';
  return 'Good evening';
}

function formatDate() {
  return new Date().toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
}

function StatCard({ label, value, sub, icon: Icon, gradient, iconBg, iconColor }) {
  return (
    <div className="relative bg-card border border-border rounded-2xl p-6 overflow-hidden shadow-sm">
      <div className={`absolute inset-0 bg-gradient-to-br ${gradient} pointer-events-none rounded-2xl`} />
      <div className="relative flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-sm font-medium text-muted-foreground">{label}</p>
          <p className="text-3xl font-outfit font-bold mt-2 text-foreground tracking-tight">{value}</p>
          {sub && <p className="text-xs text-muted-foreground mt-1">{sub}</p>}
        </div>
        <div className={`h-11 w-11 rounded-xl ${iconBg} flex items-center justify-center shrink-0`}>
          <Icon className={`h-5 w-5 ${iconColor}`} strokeWidth={1.5} />
        </div>
      </div>
    </div>
  );
}

export default function DashboardPage() {
  const { token, user } = useAuth();
  const [stats, setStats] = useState(null);
  const [recentLoads, setRecentLoads] = useState([]);
  const [mapLoads, setMapLoads] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchDashboardData = useCallback(async () => {
    try {
      const [statsRes, loadsRes] = await Promise.all([
        fetch(`${API_URL}/api/admin/stats`, { method: 'POST', headers: { Authorization: `Bearer ${token}` } }),
        fetch(`${API_URL}/api/admin/loads`, { method: 'POST', headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }, body: JSON.stringify({}) }),
      ]);
      if (statsRes.ok) setStats(await statsRes.json());
      if (loadsRes.ok) {
        const all = await loadsRes.json();
        setRecentLoads(all.slice(0, 6));
        setMapLoads(all);
      }
    } catch (err) {
      console.error('Error fetching dashboard data:', err);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchDashboardData();
    const interval = setInterval(fetchDashboardData, 30000);
    return () => clearInterval(interval);
  }, [fetchDashboardData]);

  const activeLoads = stats
    ? (stats.loads_by_status?.quoted || 0)
      + (stats.loads_by_status?.posted || 0)
      + (stats.loads_by_status?.dispatched || 0)
      + (stats.loads_by_status?.picked_up || 0)
    : null;

  
  const LoadInfoBadges = ({ listingId, loadNumber }) => (
  <div className="flex flex-wrap gap-2 mb-2">
    {/* Listing ID Badge (Blue Style) */}
    <div className="flex items-center gap-1.5 px-2 py-1 rounded-md bg-sky-50 border border-sky-100 dark:bg-sky-500/10 dark:border-sky-500/20">
      <span className="text-[9px] font-bold uppercase tracking-wider text-sky-500 opacity-80">Listing ID</span>
      <span className="text-[11px] font-mono font-bold text-sky-700 dark:text-sky-400">{listingId || 'N/A'}</span>
    </div>

    {/* Load Number Badge (Red Style) */}
    <div className="flex items-center gap-1.5 px-2 py-1 rounded-md bg-rose-50 border border-rose-100 dark:bg-rose-500/10 dark:border-rose-500/20">
      <span className="text-[9px] font-bold uppercase tracking-wider text-rose-500 opacity-80">Load ID</span>
      <span className="text-[11px] font-mono font-bold text-rose-700 dark:text-rose-400">{loadNumber || 'N/A'}</span>
    </div>
  </div>
);  

  return (
      <div className="space-y-6" data-testid="admin-dashboard">

        {/* ── Header ── */}
        <div className="flex items-start justify-between gap-4">
          <div>
            <h1 className="font-outfit text-2xl font-bold text-foreground">
              {greeting()}{user?.name ? `, ${user.name.split(' ')[0]}` : ''}
            </h1>
            <p className="text-sm text-muted-foreground mt-0.5">{formatDate()} · Operations Overview</p>
          </div>
          <Link
            to="/admin/loads"
            className="hidden sm:flex items-center gap-2 px-4 py-2 bg-accent text-white rounded-xl text-sm font-medium hover:bg-accent/90 transition-colors shrink-0"
          >
            View Loads <ArrowRight className="h-4 w-4" />
          </Link>
        </div>

{/* ── Stat Cards ── */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <StatCard
            label="Active Loads"
            value={activeLoads ?? '—'}
            sub="In pipeline"
            icon={Package}
            gradient="from-red-500/8 to-transparent"
            iconBg="bg-red-500/10"
            iconColor="text-red-500"
          />
          <StatCard
            label="Total Deposits"
            value={stats ? `$${(stats.total_deposits || 0).toLocaleString()}` : '—'}
            sub="Collected revenue"
            icon={DollarSign}
            gradient="from-emerald-500/8 to-transparent"
            iconBg="bg-emerald-500/10"
            iconColor="text-emerald-600 dark:text-emerald-400"
          />
          <StatCard
            label="Active Carriers"
            value={stats?.carriers?.active ?? '—'}
            sub="Verified & ready"
            icon={Truck}
            gradient="from-blue-500/8 to-transparent"
            iconBg="bg-blue-500/10"
            iconColor="text-blue-600 dark:text-blue-400"
          />
        </div>

        {/* ── Loads by Status Boxes ── */}
        <div className="bg-card border border-border rounded-2xl shadow-sm overflow-hidden">
            <div className="px-6 py-4 border-b border-border flex items-center gap-2">
              <Package className="h-4 w-4 text-accent" strokeWidth={1.5} />
              <h2 className="font-outfit font-semibold text-base text-foreground">Loads by Status</h2>
              {stats?.loads_by_status && (
                <span className="ml-auto text-xs text-muted-foreground">
                  {Object.values(stats.loads_by_status).reduce((a, b) => a + b, 0)} total
                </span>
              )}
            </div>
            <div className="p-4 grid grid-cols-3 sm:grid-cols-6 gap-3">
              {Object.entries(STATUS_CONFIG).map(([status, cfg]) => {
                const count = stats?.loads_by_status?.[status] ?? 0;
                return (
                  <Link
                    key={status}
                    to={`/admin/loads?status=${status}`}
                    className={`
                      group flex flex-col items-center gap-2 p-3 rounded-xl border transition-all duration-200
                      ${count > 0
                        ? `${cfg.bg} border-transparent hover:scale-105 cursor-pointer`
                        : 'bg-muted/30 border-transparent opacity-50 cursor-default pointer-events-none'
                      }
                    `}
                  >
                    <span className={`text-2xl font-outfit font-bold tabular-nums ${count > 0 ? cfg.text : 'text-muted-foreground'}`}>
                      {count}
                    </span>
                    <div className="flex items-center gap-1.5">
                      <span className={`h-1.5 w-1.5 rounded-full shrink-0 ${count > 0 ? cfg.dot : 'bg-muted-foreground/40'}`} />
                      <span className="text-[10px] font-medium text-muted-foreground leading-tight text-center">
                        {cfg.label}
                      </span>
                    </div>
                  </Link>
                );
              })}
            </div>
        </div>

        {/* ── Fleet Map ── */}
        <div className="bg-card border border-border rounded-2xl shadow-sm overflow-hidden">
          <div className="px-6 py-4 border-b border-border flex items-center gap-3">
            <MapPin className="h-4 w-4 text-accent" strokeWidth={1.5} />
            <h2 className="font-outfit font-semibold text-base text-foreground">Fleet Map</h2>
            <span className="text-xs text-muted-foreground">pickup locations by status</span>
            <div className="ml-auto flex items-center gap-3 flex-wrap">
              {[
                { color: "bg-purple-500",  label: "Quoted / Posted" },
                { color: "bg-orange-500",  label: "Dispatched" },
                { color: "bg-blue-500",    label: "Picked Up" },
                { color: "bg-teal-500",    label: "Delivered" },
                { color: "bg-red-500",     label: "Cancelled" },
              ].map(({ color, label }) => (
                <span key={label} className="flex items-center gap-1.5 text-[10px] text-muted-foreground">
                  <span className={`h-2 w-2 rounded-full ${color} shrink-0`} />
                  {label}
                </span>
              ))}
            </div>
          </div>
          <div className="relative">
            {mapLoads.length === 0 ? (
              <div className="py-12 text-center text-muted-foreground text-sm">No load data to map yet.</div>
            ) : (
              <>
                <FleetMap loads={mapLoads} />
                <div className="absolute bottom-3 right-3 z-[1000]">
                  <Link
                    to="/admin/loads"
                    className="px-3 py-1.5 bg-black/70 text-white text-xs rounded-lg backdrop-blur hover:bg-black/90 transition-colors"
                  >
                    View all loads →
                  </Link>
                </div>
              </>
            )}
          </div>
        </div>

        {/* ── Pipeline + Recent Loads ── */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">

          {/* Status Pipeline */}
          <div className="lg:col-span-2 bg-card border border-border rounded-2xl shadow-sm overflow-hidden">
            <div className="px-6 py-4 border-b border-border flex items-center gap-2">
              <Activity className="h-4 w-4 text-accent" strokeWidth={1.5} />
              <h2 className="font-outfit font-semibold text-base text-foreground">Load Pipeline</h2>
            </div>
            <div className="p-4 space-y-2">
              {stats?.loads_by_status ? (
                Object.entries(stats.loads_by_status)
                  .filter(([, count]) => count > 0)
                  .sort(([, a], [, b]) => b - a)
                  .map(([status, count]) => {
                    const cfg = STATUS_CONFIG[status] || { label: status, dot: 'bg-slate-400', bg: 'bg-slate-500/10', text: 'text-slate-500' };
                    const total = Object.values(stats.loads_by_status).reduce((a, b) => a + b, 0) || 1;
                    const pct = Math.round((count / total) * 100);
                    return (
                      <div key={status} className="flex items-center gap-3 px-3 py-2.5 rounded-xl hover:bg-muted/50 transition-colors">
                        <div className={`h-2 w-2 rounded-full ${cfg.dot} shrink-0`} />
                        <span className="text-sm text-foreground flex-1 capitalize">{cfg.label}</span>
                        <div className="flex items-center gap-3">
                          <div className="w-20 h-1.5 bg-muted rounded-full overflow-hidden hidden sm:block">
                            <div
                              className={`h-full ${cfg.dot} rounded-full transition-all duration-500`}
                              style={{ width: `${pct}%` }}
                            />
                          </div>
                          <span className={`text-sm font-semibold tabular-nums w-6 text-right ${cfg.text}`}>{count}</span>
                        </div>
                      </div>
                    );
                  })
              ) : (
                <div className="py-8 text-center text-muted-foreground text-sm">No data</div>
              )}
            </div>
          </div>

          {/* Recent Loads */}
          <div className="lg:col-span-3 bg-card border border-border rounded-2xl shadow-sm overflow-hidden">
            <div className="px-6 py-4 border-b border-border flex items-center justify-between">
              <div className="flex items-center gap-2">
                <TrendingUp className="h-4 w-4 text-accent" strokeWidth={1.5} />
                <h2 className="font-outfit font-semibold text-base text-foreground">Recent Loads</h2>
              </div>
              <Link to="/admin/loads" className="text-xs text-accent hover:text-accent/80 font-medium transition-colors flex items-center gap-1">
                See all <ArrowRight className="h-3 w-3" />
              </Link>
            </div>

            <div className="divide-y divide-border">
              {recentLoads.length === 0 && !loading ? (
                <div className="py-12 text-center text-muted-foreground text-sm">No loads yet</div>
              ) : (
                recentLoads.map((load) => {
                  const cfg = STATUS_CONFIG[load.status] || { label: load.status, dot: 'bg-slate-400', bg: 'bg-slate-400/10', text: 'text-slate-500' };
                  return (
                    <Link
                      key={load.id}
                      to={`/admin/loads/${load.id}`}
                      className="flex items-center gap-4 px-6 py-4 hover:bg-muted/40 transition-colors"
                      data-testid={`recent-load-${load.id}`}
                    >
                      {/* Vehicle */}
                      <div className="h-9 w-9 rounded-xl bg-accent/10 flex items-center justify-center shrink-0">
                        <Package className="h-4 w-4 text-accent" strokeWidth={1.5} />
                      </div>

                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-semibold text-foreground truncate">
                          {load.year} {load.vehicle_make} {load.vehicle_model}
                        </p>
                        <LoadInfoBadges 
                                  listingId={load.central_dispatch_listing_id} 
                                  loadNumber={load.cd_dispatch_snapshot?.loadNumber} 
                                />
                        <div className="flex items-center gap-1 mt-0.5">
                          <MapPin className="h-3 w-3 text-muted-foreground shrink-0" strokeWidth={1.5} />
                          <p className="text-xs text-muted-foreground truncate">
                            {load.pickup_zip} → {load.delivery_zip}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-center gap-3 shrink-0">
                        {load.risk_flags?.length > 0 && (
                          <AlertTriangle className="h-4 w-4 text-amber-500" strokeWidth={1.5} />
                        )}
                        <span className="text-sm font-bold text-foreground tabular-nums">
                          ${load.customer_price?.toFixed(0) ?? '—'}
                        </span>
                        <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold ${cfg.bg} ${cfg.text}`}>
                          <span className={`h-1.5 w-1.5 rounded-full ${cfg.dot}`} />
                          {cfg.label}
                        </span>
                      </div>
                    </Link>
                  );
                })
              )}
            </div>
          </div>
        </div>

      </div>
  );
}
